import axios from "axios";
import { store } from "@/store";
import { router } from "@/router";

export const httpClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

httpClient.interceptors.request.use(
  (config) => {
    const { token } = store.state.auth;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      switch (error.response.data.message[0]) {
        case "AUTH_INVALID_TOKEN":
          return store.dispatch("refresh").then(() => {
            error.config.headers.Authorization = `Bearer ${store.state.auth.token}`;
            return axios.request(error.config);
          });
        case "AUTH_INVALID_REFRESH_TOKEN":
          if (router.currentRoute.matched.length) {
            router.push({ name: "Login" });
          }
          store.commit("LOGOUT");
          break;
      }
    }
    return Promise.reject(error);
  }
);
